<script lang="ts" setup>
  import { onBeforeUnmount, watch } from 'vue'
  import ReportDownloadsPanel from '~/components/reports/downloads/ReportDownloadsPanel.vue'
  import { useReportRuns } from '~/composables/reports/useReportRuns'
  import { useReportDownloadsStore } from '~/stores/reportDownloadsStore'
  import { REPORT_DOWNLOADS_RUN_LIMIT } from '~/utils/reports/downloads-grouping'

  const store = useReportDownloadsStore()
  const runs = useReportRuns({ limit: REPORT_DOWNLOADS_RUN_LIMIT })

  watch(runs.activeCount, (count) => store.setActiveCount(count), { immediate: true })

  onBeforeUnmount(() => {
    store.setActiveCount(0)
    store.close()
  })
</script>

<template>
  <ReportDownloadsPanel :runs="runs" />
</template>
